import { gql } from '@grandvisionhq/graphql';
import { contactLensLineItemFragment, prescriptionGlassLineItemFragment, solutionLineItemFragment, contactLensBundleLineItemFragment, nonPrescriptionBundleOrderLineItemFragment, regularLineItemFragment } from '../fragments/line-item.js';

const GET_ORDER_BY_TOKEN = gql`
  query GetOrderByToken($token: String!) {
    getOrderByToken(token: $token) {
      billingAddress {
        firstName
        lastName
        streetName
        streetNumber
        additionalStreetInfo
        city
        postalCode
        region
        countryCode
        externalId
        company
      }
      orderDate
      orderNumber
      paymentMethod
      paymentStatus
      receiptUrl
      shippingAddress {
        firstName
        lastName
        streetName
        streetNumber
        additionalStreetInfo
        city
        postalCode
        region
        countryCode
        externalId
        company
      }
      deliveryMethod
      price {
        currencyCode
        discountedAmount
        paymentMethodPrice
        shippingPrice
        subtotal
        total
      }
      shipmentStatus
      shipmentTrackingURL
      customerDetails {
        phone
        email
        dateOfBirth
        code
        IBAN
      }
      invoiceDetails {
        certifiedEmail
        vatId
        code
        certifiedRecipientCode
        insuranceProvider
        insuranceNumber
      }
      serviceStore {
        name
        streetName
        streetNumber
      }
      lineItems {
        ... on OrderLineItemRegular {
          ...RegularOrderLineItemFragment
        }
        ... on OrderLineItemContactLens {
          ...ContactLensOrderLineItemFragment
        }
        ... on OrderLineItemPrescriptionGlass {
          ...PrescriptionGlassOrderLineItemFragment
        }
        ... on OrderLineItemSolution {
          ...SolutionOrderLineItemFragment
        }
        ... on OrderLineItemBundle {
          ...ContactLensBundleOrderLineItemFragment
        }
        ... on OrderLineItemNonPrescriptionBundle {
          ...NonPrescriptionBundleOrderLineItemFragment
        }
      }
    }
  }
  ${contactLensLineItemFragment}
  ${prescriptionGlassLineItemFragment}
  ${solutionLineItemFragment}
  ${contactLensBundleLineItemFragment}
  ${nonPrescriptionBundleOrderLineItemFragment}
  ${regularLineItemFragment}
`;

export { GET_ORDER_BY_TOKEN };
//# sourceMappingURL=get-order-by-token.js.map
